/**
 * @param {string} s
 * @returns {string}
 */
export const ucfirst = s => s[0].toUpperCase() + s.substr(1)
